'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './banking-accounts-list.routes';

export class BankingAccountsListComponent {
  constructor(Auth, BankingAccountsService, dialogs, $uibModal) {
    'ngInject';

    this.dialogs = dialogs;
    this.Auth = Auth;
    this.BankingAccountsService = BankingAccountsService;
    this.$uibModal = $uibModal;

    this.BankingAccountsService.getByUser({id: this.Auth.getCurrentUserSync()._id}, data => {
      this.accounts = data;
    });
  }

  delete(account) {
    var that = this;

    var dlg = this.dialogs.confirm("Delete Banking Account?", "Do you really want to delete the banking account?" +
      "<br/><br/><b>" + account.name + "</b>");
    dlg.result.then(() => {
      that.BankingAccountsService.delete({id: account._id},
        () => {
          that.accounts = that.accounts.filter(function( obj ) {
            return obj._id !== account._id;
          });
        },
        err => {
          alert("Could not delete banking account");
        });
    }, () => {
      // Cancel
    });
  }

  verify(account) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      size: 'sm',
      component: 'bankingAccountVerification',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function (payments) {

        if (payments[0] == 7 && payments[1] == 13) {
          account.status = 'verified';
          that.BankingAccountsService.update({id: account._id}, account, _ => {
            that.BankingAccountsService.getByUser({id: that.Auth.getCurrentUserSync()._id}, data => {
              that.accounts = data;
              that.dialogs.notify("Verification Success","Your Banking Account has been successfully verified.<br/>You can now use the account to process ACH payments");
            });
          }, _ => {

          })
        } else {
          that.dialogs.error("Verification Failed", "The micropayments you entered are not correct.");
        }

      },
      function () { /* cancel */ }
    );
  }

  requestVerification(account) {
    let dlg = this.dialogs.confirm("Request Verification","<b>When you start the verification process, <u>two small payments</u> (micropayments) will be transferred to your bank account in the <u>next couple of days</u>. These will be used to verify your account.</b><br/><br/>Once the verification process has started, you will no longer be able to change your account or routing number.<br/><br/>Do you want to start the verification process now?");

    dlg.result.then(_ => {
      account.status = 'pending';
      this.BankingAccountsService.update({id: account._id}, account, _=> {
        this.BankingAccountsService.getByUser({id: this.Auth.getCurrentUserSync()._id}, data => {
          this.accounts = data;
        });
      }, _=> {})
    }, _ => {
      // no
    });
  }
}

export default angular.module('conduuApp.bankingAccountsList', [uiRouter])
  .config(routes)
  .component('bankingAccountsList', {
    template: require('./banking-accounts-list.html'),
    controller: BankingAccountsListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/user/banking-accounts/list/banking-accounts-list.component.js